"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleReportsResource = handleReportsResource;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const listReports_1 = require("../../../app/dist/listReports");
/**
 * loom://reports — every report artifact on disk as
 * { id, title, kind, weaveSlug, generated_at, filePath }.
 *
 * Reports are leaf snapshots kept out of LoomState (storage decision A), so the
 * tree cannot find them in loom://state. This resource is the SINGLE read the
 * extension consumes to render the Reports node — it never fs-scans loom docs
 * itself (vscode → mcp → app + fs stays intact). Pure read.
 */
async function handleReportsResource(root, uri) {
    const reports = await (0, listReports_1.listReports)({
        getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root),
        fs,
    });
    return {
        contents: [{
                uri,
                mimeType: 'application/json',
                text: JSON.stringify({ reports }, null, 2),
            }],
    };
}
